import React from 'react';
import { connect } from 'react-redux';

import { Box, Card, CardActionArea, Chip, LinearProgress, Typography } from '@mui/material';
import * as Utils from './ConnectorCardUtil';
import * as UIAction from '../../redux/actions/ui.actions';
import { isEntityLinked } from '../../api/client';
import { getLogoUrl } from '@hotglue/common';
import { Alert } from '../popupAlerts';

const SupportedConnectorCard = ({ connector, demo, flow, hasLinkedConnector }) => {
  const { label, id, version } = connector;
  const [isLoading, setLoading] = React.useState(false);

  const icon = getLogoUrl(connector);

  const preLink = async () => {
    if (hasLinkedConnector) {
      Alert({ text: 'Disconnect linked connector before switching to another', type: 'error' });
      return;
    }

    if (demo) {
      Alert({ type: 'info', text: `Sorry, you can't connect connector in demo mode!` });
      return;
    }

    setLoading(true);
    // Check if connector is already linked in another flow
    const oFlows = await isEntityLinked(id);

    const filteredFlows = Array.isArray(oFlows) && oFlows.filter((f) => f.id !== flow);

    if (filteredFlows && filteredFlows.length > 0) {
      setLoading(false);
      // Ask if they want to copy tap config from one of these
      UIAction.showCopyEntity(connector, oFlows, 'connector');
    } else {
      await Utils.doLink(connector);
      setLoading(false);
    }
  };

  return (
    <Card
      elevation={0}
      sx={{
        height: '160px',
        border: ({ palette }) => `1px solid ${palette.common.outline}`,
        opacity: hasLinkedConnector ? 0.5 : 1,
      }}
    >
      {isLoading && <LinearProgress />}
      <CardActionArea
        id="SupportedConnectorCard"
        disabled={hasLinkedConnector}
        onClick={() => preLink()}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          position: 'relative',
          gap: 2,
        }}
      >
        <Box component="img" role={'img'} alt={`image for ${label} connector`} src={icon} width="48px" height="48px" sx={{ objectFit: 'contain' }} />
        <Typography variant="h2" textAlign="center">
          {label}
        </Typography>
        {version && (
        <Box
          sx={{
            position: 'absolute',
            bottom: 10,
            right: 10,
          }}
        >
          <Chip
            role='tooltip'
            aria-label='connector version'
            label={version}
            size="small"
            sx={{ color: '#676767', fontSize: '10px', height: '18px', fontWeight: '300' }}
          />
        </Box>
        )}
      </CardActionArea>
    </Card>
  );
};

const mapStateToProps = (state, props) => {
  return {
    demo: state.configuration.demo || state.preferences.demoMode,
    flow: state.flows.selectedFlow,
  };
};

export default connect(mapStateToProps)(SupportedConnectorCard);
